import { Quill } from "../patches/PatchedQuill";
export const supportedFormats = ['bold', 'italic', 'link', 'strike', 'underline', 'header', 'indent', 'list'];

/** Rich text is always saved as a stringified object. This is the object interface once parsed. */

export function extractQuillDelta(maybeRichText) {
  try {
    const parsed = JSON.parse(maybeRichText);
    if (parsed.type === 'quill-delta' && 'value' in parsed) {
      return parsed;
    }
    return null;
  } catch (error) {
    return null;
  }
}
export function isEmptyRichText(richText) {
  return richText.value.ops.length === 0 || richText.value.ops.length === 1 && richText.value.ops[0].insert.replaceAll('\\n', '').replaceAll('\n', '').trim() === '';
}
export function isEmptyRichTextString(richTextString) {
  if (!richTextString) {
    return true;
  }
  const parsed = extractQuillDelta(richTextString);
  if (!parsed) {
    return true;
  }
  return isEmptyRichText(parsed);
}
export function normalizeDescription(description) {
  return isEmptyRichText(description) ? '' : JSON.stringify(description);
}
export function convertStrToRichText(maybeHTML) {
  const isHTML = maybeHTML.match(/(<([^>]+)>)/gi) != null;
  if (!isHTML) {
    return maybeHTML;
  } else {
    const containerEl = document.createElement('div');
    containerEl.style.height = '0';
    containerEl.style.visibility = 'hidden';
    document.body.appendChild(containerEl);
    const quill = new Quill(containerEl, {
      formats: supportedFormats
    });
    quill.clipboard.dangerouslyPasteHTML(maybeHTML);
    const pastedDelta = quill.getContents();
    document.body.removeChild(containerEl);
    const richTextString = JSON.stringify(makeParsedRichText(pastedDelta));
    return richTextString.replace(/<([^>]+)>/g, '&lt;$1&gt;');
  }
}
export function convertHTMLToRichText(html) {
  const isHTML = html.match(/(<([^>]+)>)/gi) != null;
  if (!isHTML) {
    return makeParsedRichText({
      ops: [{
        insert: html
      }]
    });
  }
  const ops = [];
  const sections = html.split(/(?=<strong>)/).filter(s => s.trim());
  sections.forEach((section, index) => {
    if (index > 0) {
      ops.push({
        insert: '\n'
      });
    }
    const headerMatch = section.match(/<strong>(.*?)<\/strong>/);
    if (headerMatch) {
      ops.push({
        insert: headerMatch[1],
        attributes: {
          bold: true,
          underline: true
        }
      });
      ops.push({
        insert: '\n'
      });
    }
    const listMatch = section.match(/<ul>[\s\S]*?<\/ul>/);
    if (listMatch) {
      const items = listMatch[0].match(/<li>(.*?)<\/li>/g) || [];
      items.forEach(item => {
        const text = item.replace(/<\/?li>/g, '').trim();
        ops.push({
          insert: text
        });
        ops.push({
          insert: '\n',
          attributes: {
            list: 'bullet'
          }
        });
      });
    }
    const remainingText = section.replace(/<strong>.*?<\/strong>/, '').replace(/<ul>[\s\S]*?<\/ul>/, '').replace(/<[^>]*>/g, '').replace(/\n+/g, ' ').trim();
    if (remainingText) {
      ops.push({
        insert: remainingText
      });
      ops.push({
        insert: '\n'
      });
    }
  });
  return makeParsedRichText({
    ops
  });
}
export function makeParsedRichText(value) {
  return {
    type: 'quill-delta',
    value
  };
}
export function convertRichTextToHTML(richTextString) {
  if (!richTextString) {
    return '';
  }
  const parsed = extractQuillDelta(richTextString);
  if (!parsed) {
    return '';
  }
  if (isEmptyRichText(parsed)) {
    return '';
  }
  const containerEl = document.createElement('div');
  containerEl.style.height = '0';
  containerEl.style.visibility = 'hidden';
  document.body.appendChild(containerEl);
  const quill = new Quill(containerEl, {
    formats: supportedFormats
  });
  quill.setContents(parsed.value);
  const html = quill.getSemanticHTML();
  document.body.removeChild(containerEl);
  return html;
}